import { ARTIST_CATEGORY, ArtistCategory } from '@favid-inc/api';
import { formFactory, FormValues } from 'core/form';
import { FormField } from 'core/form';
import { Action } from 'core/generic';
import _ from 'lodash';
import React from 'react';
import { toast } from 'react-toastify';
import { SubmissionError } from 'redux-form';
import { Categorie, updateCategories } from './';

const fieldList: FormField[] = [{ name: 'categoria', label: 'Categoria' }];

const Form = formFactory<ArtistCategory>(ARTIST_CATEGORY);

interface Props {
  list: Categorie[];
  dispatch: (action: Action) => void;
}

class CreateCategoryComponent extends React.Component<Props> {
  onSubmit = async ({ categoria }: FormValues) => {
    try {
      if (!categoria || !categoria.trim()) {
        throw new SubmissionError({
          categoria: 'Nome Inválido',
          _error: 'nome invalido',
        });
      }

      const isExistingCategorie = _.some(this.props.list, (item) => item.description === categoria);
      if (isExistingCategorie) {
        throw new SubmissionError({
          categoria: 'Categoria ja existe',
          _error: 'categoria duplicada',
        });
      }

      updateCategories(categoria, this.props.dispatch);
    } catch (e) {
      if (e instanceof SubmissionError) {
        throw e;
      }
      toast.error('Ocorreu um erro ao cadastrar a categoria, tente novamente');
    }
  };

  render() {
    return (
      <div>
        <div className='ui header'>
          <h3>Adicionar categoria</h3>
        </div>
        <Form fieldList={fieldList} submitHandler={this.onSubmit} />
      </div>
    );
  }
}

export const CreateCategory = CreateCategoryComponent;
